

function activeRecipeFeatures($) {

	function filterRecipes() {
		var filters = []
		$('.franklin-recipes .item-filter-list > ul ul').each(function () {
			var row = []
			$(this).find('input[type=checkbox]').each(function () {
				if ($(this).prop('checked')) {
					row.push($(this).closest('li').attr('data-slug'))
				}
			})
			if (row.length > 0) {
				filters.push(row)
			}
		})

		$recipes = $('.franklin-recipes .recipe-tile').hide()
		for (var i = 0; i < filters.length; i++) {
			var row = filters[i]
			$recipes = $recipes.filter(function (idx, el) {
				var dataCategoryIds = $(el).attr('data-categories').split(' ')
				for (var j = 0; j < row.length; j++) {
					if (dataCategoryIds.indexOf(row[j]) > -1) {
						return true
					}
				}

				return false
			})
		}
		$recipes.show()
		/*
		$ids = $recipes.map(function (idx, el) {
			return $(el).attr('data-category-ids')
		})
		*/
	}
	$('.item-filter-list input[type=checkbox]').on('click', function(evt) {
		filterRecipes()
	})
}

module.exports = activeRecipeFeatures